import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"

import ReloadableWidget from "src/components/ReloadableWidget"
import TrackingLink from "src/components/TrackingLink"

import { queryReviews } from "src/api/Dashboard"

import DashboardTooltip from "./DashboardTooltip"

const refreshRate = 300 * 1000 // 5 minutes

const renderData = (count) => {
  if (count > 0) {
    return (
      <div className="flex flex-col">
        <div className="mb-2 flex">
          <i className="fa-solid fa-star mr-2 text-xl" />
          <span className="mr-1 text-xl font-bold">{count}</span>
        </div>
        <span>{pluralize("unanswered reviews", count)}</span>
      </div>
    )
  } else {
    return (
      <div className="flex items-center">
        <i className="fa-solid fa-star mr-2 text-xl" />
        <span>No unanswered reviews</span>
      </div>
    )
  }
}

const Reviews = ({ marinaSlug }) => {
  const { isLoading, isError, data } = useQuery(
    ["reviews", marinaSlug],
    () => queryReviews(marinaSlug),
    { retry: false, refetchInterval: refreshRate, refetchOnWindowFocus: false }
  )

  return (
    <ReloadableWidget isLoading={isLoading} isError={isError}>
      {data && (
        <TrackingLink
          href={data.reviewsLink}
          className="card relative flex w-full items-center justify-between p-6 text-center text-gray-900 no-underline hover:border-blue-800 hover:bg-blue-50 hover:text-blue-700"
          eventName="reviews_widget:clicked"
        >
          <DashboardTooltip />
          {renderData(data.unansweredReviewsCount)}
          <i className="fa-solid fa-chevron-right mt-0.5 text-xs font-semibold" />
        </TrackingLink>
      )}
    </ReloadableWidget>
  )
}

Reviews.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
}

export default Reviews
